import { useState, useCallback } from 'react';
import { playbookApi } from '../api/playbookApi';
import type { InstanceDiagnostics } from '../types/playbook.types';

export function usePlaybookDiagnostics(instanceId: string | null) {
  const [diagnostics, setDiagnostics] = useState<InstanceDiagnostics | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!instanceId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await playbookApi.getDiagnostics(instanceId);
      const data = res as any;
      setDiagnostics(data);
    } catch (err) {
      console.error('[usePlaybookDiagnostics] Failed to load diagnostics:', err);
      setError(err instanceof Error ? err.message : 'Failed to load diagnostics');
    } finally {
      setLoading(false);
    }
  }, [instanceId]);

  return { diagnostics, loading, error, refresh };
}
